import { Skeleton, Stack } from '@mui/material';

export const DashboardSkeleton = () => (
    <Stack spacing={3}>
        <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
        </Stack>
        <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
            <Skeleton variant="rounded" height={140} sx={{ flex: 1, minWidth: 220, borderRadius: '16px' }} />
        </Stack>
        <Skeleton variant="rounded" height={380} sx={{ borderRadius: '16px' }} />
    </Stack>
);
